import {
  collection,
  getDocs,
  doc,
  getDoc,
  setDoc,
  updateDoc,
  addDoc,
  where,
  query,
  deleteDoc,
  orderBy,
  limit,
} from 'firebase/firestore';

async function getDocumentById(db, collectionName, docId) {
  const docRef = await getDoc(doc(db, collectionName, docId));
  if (!docRef.exists()) return null;
  const data = { ...docRef.data(), ...{ $id: docRef.id } };
  return data;
}

async function getCollection(
  db,
  collectionName,
  whereConfig,
  orderByConfig,
  limitValue
) {
  let collectionQuery;

  const collectionRef = collection(db, collectionName);

  // Checks if whereConfig is an array to perform multiple queries
  if (whereConfig && Array.isArray(whereConfig)) {
    whereConfig.forEach(({ key, operator, value }) => {
      if (collectionQuery)
        collectionQuery = query(collectionQuery, where(key, operator, value));
      if (!collectionQuery)
        collectionQuery = query(collectionRef, where(key, operator, value));
    });
  } else if (whereConfig) {
    collectionQuery = query(
      collectionRef,
      where(whereConfig.key, whereConfig.operator, whereConfig.value)
    );
  }

  if (orderByConfig) {
    if (collectionQuery)
      collectionQuery = query(
        collectionQuery,
        orderBy(orderByConfig.key, orderByConfig.direction)
      );
    else if (!collectionQuery)
      collectionQuery = query(
        collectionRef,
        orderBy(orderByConfig.key, orderByConfig.direction)
      );
  }

  if (limitValue) {
    if (collectionQuery)
      collectionQuery = query(collectionQuery, limit(limitValue));
    else if (!collectionQuery)
      collectionQuery = query(collectionRef, limit(limitValue));
  }

  const docs = await getDocs(collectionQuery ? collectionQuery : collectionRef);

  const data = docs.docs.map((doc) => {
    return { ...doc.data(), ...{ $id: doc.id } };
  });

  return data;
}

async function updateDocById(db, collectionName, docId, data = {}) {
  try {
    const docRef = doc(db, collectionName, docId);
    return await updateDoc(docRef, data);
  } catch (error) {
    console.log('updateDocById error:', error);
    throw new Error(error);
  }
}

async function setDocById(db, collectionName, docId, docData, merge = true) {
  await setDoc(doc(db, collectionName, docId), docData, {
    merge: merge,
  });
  return 'success';
}

async function addDocToCollection(db, collectionName, docData) {
  return await addDoc(collection(db, collectionName), docData);
}

async function deleteDocByCollectionAndId(db, collectionName, id) {
  const docRef = doc(db, collectionName, id);
  return await deleteDoc(docRef);
}

function generateDocId(db, collectionName) {
  return doc(collection(db, collectionName)).id;
}

export {
  getDocumentById,
  getCollection,
  setDocById,
  updateDocById,
  addDocToCollection,
  deleteDocByCollectionAndId,
  generateDocId,
};
